import { ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166 } from 'cpool-constants';
import { z } from 'zod';

import { schemaConsorsCity } from './city.schema';
import { schemaConsorsContactAddressBasic } from './contactAddressBasic.schema';
import { schemaConsorsDateYYYYMM } from './date-yyyy-mm.schema';
import { schemaConsorsStreet } from './street.schema';
import { schemaConsorsZipcode } from './zipcode.schema';

export const schemaConsorsContactAddressMain = schemaConsorsContactAddressBasic
    .merge(
        z.object({
            city: schemaConsorsCity,
            country: z.nativeEnum(ALPHA_2_ISO_3166_MATCH_NUMERIC_ISO_3166),
            street: schemaConsorsStreet,
            validFrom: schemaConsorsDateYYYYMM,
            zipcode: schemaConsorsZipcode,
        }),
    )
    .refine(
        (data) => {
            if (data.telephoneLandline === undefined && data.telephoneMobile === undefined) return false;
            return true;
        },
        { message: 'telephoneLandline or telephoneMobile must be defined' },
    );
